import React from 'react';
import Layout from '../../components/Layout';
import CompanyProjects from './CompanyProjects';

const title = 'Project Marketplace — BestHand for Companies';
const description =
  'Browse large home-improvement and construction projects in your service area, '
  + 'review masked project details and guided photos, and submit line-item quotes — '
  + 'BestHand Large Projects for verified companies.';

async function action({ largeProjectsEnabled }) {
  // LARGE PROJECTS FLAG: when OFF this LP route is unreachable -> redirect home
  // (additive guard; small-jobs routes untouched). Flag read from the router
  // context (server-only DB read in server.js / SSR-seeded runtime on client);
  // fail-closed at the source.
  if (!largeProjectsEnabled) {
    return { redirect: '/' };
  }
  return {
    title,
    description,
    component: (
      <Layout companyMode>
        <CompanyProjects />
      </Layout>
    ),
  };
}

export default action;
